import { render, staticRenderFns } from "./LicencesCompanyTable.vue?vue&type=template&id=649906b1"
import script from "./LicencesCompanyTable.vue?vue&type=script&lang=js"
export * from "./LicencesCompanyTable.vue?vue&type=script&lang=js"
import style0 from "./LicencesCompanyTable.vue?vue&type=style&index=0&id=649906b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports